class Charts.UserRanking extends Backbone.Model
  url: '/monitoring/dashboard/charts/user/facebook'

  spanSize: ->
    @get('spanSize')

  title: ->
    @get('title')

  status: ->
    @get('status')

  rankId: ->
    @get('id')

  result: ->
    @get('result')

  hasErrors: ->
    @get('errors')

  settings: ->
    id: @rankId()
    status: @status()
    spanSize: @spanSize()
    title: @title()

  updateResult: (result) =>
    @set('result', result)
    @trigger('ranking:load:finished', @)

  loadData: (searchQuery, limit, onError) ->
    query = searchQuery.deepCopy()

    query.addStatus(@status()) if @status()
    query.set('resultsAmount', limit)

    @set('request', $.ajax(
      type: "POST"
      url: @url
      global: false
      data: query.toJSON()
      success: @updateResult
      error: onError
    ))

  abortRequest: ->
    request = @get('request')
    request.abort() if request?